<template>
	<div
		class="c-slideInOverlay"
		:class="[{ 'is-open': isOpen }, { 'is-closed': !isOpen }]"
	>
		<transition name="fade">
			<div
				class="c-slideInOverlay__background"
				@click="close"
				v-if="isOpen"
			></div>
		</transition>
		<div class="c-slideInOverlay__slidein" :class="placementClass">
			<div class="inner" v-if="isOpen">
				<div class="inner__header">
					<slot name="header"></slot>
				</div>
				<div class="inner__body">
					<slot name="body"></slot>
				</div>
				<div class="inner__footer">
					<slot name="footer"></slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SlideInOverlay',
	components: {},

	data: () => ({}),

	props: {
		isOpen: {
			type: Boolean,
			default: false,
		},
		placement: {
			type: String,
			default: 'right',
		},
	},
	computed: {
		placementClass() {
			return 'c-slideInOverlay__slidein--' + this.placement;
		},
	},
	methods: {
		close() {
			this.$emit('close');
		},
		keyDownHandler(e) {
			if (e.key == 'Escape' && this.isOpen) {
				this.$emit('close');
			}
			if (e.key == 'Enter' && this.isOpen) {
				this.$emit('enter');
			}
		},
	},
	created() {
		window.addEventListener('keydown', this.keyDownHandler);
	},
	destroyed() {
		window.removeEventListener('keydown', this.keyDownHandler);
	},
};
</script>

<style lang="scss">
@import '@backend/scss/abstracts/variables.scss';
@import '@backend/scss/abstracts/mixins.scss';

.c-slideInOverlay {
	position: relative;

	.is-closed {
		transition: $t-hover;
		pointer-events: none;
		opacity: 0;
	}

	&__background {
		background-color: $c-overlay;
		bottom: 0;
		left: 0;
		position: fixed;
		right: 0;
		top: 0;
		z-index: 20;
	}

	&__slidein {
		transition: $t-nice;
		display: flex;
		max-height: 100%;
		position: fixed;
		z-index: 20;
		top: 0;
		bottom: 0;
		opacity: 0;
		width: 100%;
		max-width: 490px;
		background-color: $c-white;
		bottom: 0;
		box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
		transition: transform 500ms $t-nice, opacity 300ms $t-nice;

		&--left {
			left: 0;
			transform: translate(-100%, 0);
		}

		&--right {
			right: 0;
			transform: translate(100%, 0);
		}

		.is-open & {
			transition: $t-hover;
			opacity: 1;
			transform: translate(0, 0);
		}

		.inner {
			width: 100%;
			height: 100%;

			display: flex;
			flex-direction: column;

			&__header {
				flex: 0 0 auto;
			}

			&__body {
				@include scroll-custom();
				flex: 1;
				overflow: auto;
			}

			&__footer {
				flex: 0 0 auto;
			}
		}
	}

	&.is-open {
		.c-slideInOverlay__inner {
			opacity: 1;
			transform: translate(0, 0);
		}
	}
}
</style>
